import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import NotFound from "./pages/NotFound";
import LoginPage from "./pages/Login";
import Layout from "./Layout/Layout";
import Dashborad from "./pages/Dashboard";
import TourLists from "./Components/TourLists/TourLists";
import ManageTourStepper from "./Components/ManageTour/ManageTourStepper";
import InfoUser from "./Components/InfoUser/InfoUser";
import TourListProvider from "./Providers/TourListProvider";
import AddPackage from "./Components/AddPackage/AddPackage";
import RequireAuth from "./Components/RequireAuth/RequireAuth";
import { useUser } from "./Providers/UserProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RulesPage from "./Components/Rules/Rules";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ContentLoading from "./Components/Loading/Loading";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const THEME = createTheme({
  typography: {
    fontFamily: `iranyekan`,
  },
});

function App() {
  const queryClient = new QueryClient();
  const user = useUser();
  return (
    <ThemeProvider theme={THEME}>
      <TourListProvider>
        <QueryClientProvider client={queryClient}>
          <ToastContainer rtl />
          <Layout>
            <Routes>
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate replace to="/404" />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/"
                element={
                  <RequireAuth>
                    <Dashborad />
                  </RequireAuth>
                }
              >
                <Route
                  path="/tourlist"
                  element={
                    <RequireAuth>
                      {user?.FloatingCompanyId ? (
                        <TourLists />
                      ) : (
                        <ContentLoading />
                      )}
                    </RequireAuth>
                  }
                />
                <Route
                  path="/manageTours/:id"
                  element={
                    <RequireAuth>
                      <ManageTourStepper />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/addPackage"
                  element={
                    <RequireAuth>
                      <AddPackage />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/info"
                  element={
                    <RequireAuth>
                      <InfoUser />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/rules"
                  element={
                    <RequireAuth>
                      <RulesPage />
                    </RequireAuth>
                  }
                />
              </Route>
            </Routes>
          </Layout>
        </QueryClientProvider>
      </TourListProvider>
    </ThemeProvider>
  );
}

export default App;
